/**
 * Asynchronously loads the component for SendingCalendarPage
 */

import { lazyLoad } from 'utils/loadable';

export const SendingCalendarPage = lazyLoad(
  () => import('./index'),
  module => module.default,
);
